import styled from 'styled-components';
import { CloudImage } from '@components/CloudImage';
import { Columns } from '@components/Columns';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';

export const Container = styled(Columns)<{ $isHorizontal?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: ${({ $isHorizontal }) => ($isHorizontal ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  padding-left: ${themeSpace(10)};
  padding-right: ${themeSpace(10)};
  padding-top: ${themeSpace(11)};
  padding-bottom: ${themeSpace(12)};
  ${themeMediaQuery('sm')} {
    padding-left: ${themeSpace(0)};
    padding-right: ${themeSpace(0)};
  }
  ${themeMediaQuery('md')} {
    padding-left: ${themeSpace(10)};
    padding-right: ${themeSpace(10)};
  }
  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    padding-left: ${themeSpace(3)};
    padding-right: ${themeSpace(3)};
    padding-bottom: ${themeSpace(9)};
    padding-top: ${themeSpace(9)};
  }
`;

export const TextWrapper = styled(Columns.Column)<{ $isHorizontal?: boolean }>`
  width: ${({ $isHorizontal }) => ($isHorizontal ? '50%' : '100%')};
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    div {
      justify-content: center;
      align-items: center;
      p {
        text-align: center;
      }
    }
  }
`;

export const CloudAsset = styled(CloudImage)<{ $isHorizontal?: boolean }>`
  width: 100%;
  margin-bottom: ${({ $isHorizontal }) => ($isHorizontal ? themeSpace(0) : themeSpace(7))};
  max-width: 532px;
  ${themeMediaQuery('below_sm')} {
    margin-bottom: ${themeSpace(7)};
    max-width: 100%;
  }
`;

export const CloudWrapper = styled(Columns.Column)<{ $isHorizontal?: boolean }>`
  width: ${({ $isHorizontal }) => ($isHorizontal ? '50%' : '65%')};
  text-align: center;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const MainTextPairing = styled(TextPairing)<{ maxWidth?: string }>`
  .text-pairing-title {
    max-width: ${(props) => props.maxWidth};
    ${themeMediaQuery('xl')} {
      max-width: 755px;
    }
  }
`;
